class CsvRef {
  constructor() {
    this._discriminator = 'csv'; // used for deserialization on server
  }

  name() {
    return 'CSV';
  }
}

export default CsvRef;
